module.exports = __webpack_public_path__ + "img/GYLFW_12.d1408bc4.jpg";